import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/get-shopping-cart-session';

  return API({ endpoint });
}
